import { render, staticRenderFns } from "./customer_reviews.vue?vue&type=template&id=1c20a3da&scoped=true&"
import script from "./customer_reviews.vue?vue&type=script&lang=js&"
export * from "./customer_reviews.vue?vue&type=script&lang=js&"
import style0 from "./customer_reviews.vue?vue&type=style&index=0&id=1c20a3da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20a3da",
  null
  
)

export default component.exports